/**
 * Authentication utility functions
 */

/**
 * Determines if an error message indicates an authentication-related issue
 * @param errorMessage The error message to check
 * @returns true if the error is authentication-related
 */
export const isAuthenticationError = (errorMessage: string): boolean => {
  return (
    errorMessage.includes('authentication token') ||
    errorMessage.includes('Authentication failed') ||
    errorMessage.includes('Please check your credentials') ||
    errorMessage.includes('401') ||
    errorMessage.includes('Unauthorized')
  );
};

/**
 * Redirects user to Prodikt homepage for login
 */
export const redirectToProdiktLogin = (): void => {
  window.open('https://app.prodikt.com/', '_blank');
};
